module.exports = __webpack_public_path__ + "img/x-Of.9303bb2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shot-images/x-Of.jpg
// module id = CO4S
// module chunks = 1